import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=1ec92f42&scoped=true&lang=pug&"
import script from "./Footer.vue?vue&type=script&lang=js&"
export * from "./Footer.vue?vue&type=script&lang=js&"
import style0 from "./Footer.styl?vue&type=style&index=0&id=1ec92f42&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec92f42",
  null
  
)

export default component.exports